module.exports = __webpack_public_path__ + "static/media/iguazu-falls-42.5ee84641.jpg";